interface FieldRequirement {
  field: string;
  value?: string | number;
}

interface ResourceMapping {
  require_fields: FieldRequirement[];
  chargebeeAppUrl: string;
  allowedOperations: string[];
  responseObjectKey: string;
  subResources?: { [subResourceKey: string]: ResourceMapping };
}

interface ResourceUrlMapping {
  [resourceKey: string]: ResourceMapping;
}

export const resourceUrlMapping: ResourceUrlMapping = {
  //Identified as parentMapping in the ChargebeeSiteLink.tsx
  customers: {
    require_fields: [{ field: 'id' }],
    chargebeeAppUrl: '{protocol}://{site}.{domain}/d/customers/{id}',
    allowedOperations: [
      'create_a_customer',
      'update_a_customer',
      'retrieve_a_customer',
    ],
    responseObjectKey: 'customer',
  },
  items: {
    require_fields: [],
    chargebeeAppUrl: '',
    allowedOperations: ['create_an_item', 'update_an_item', 'retrieve_an_item'],
    responseObjectKey: 'item',
    subResources: {
      //Identified as subMapping in the ChargebeeSiteLink.tsx
      plans: {
        require_fields: [{ field: 'id' }, { field: 'type', value: 'plan' }],
        chargebeeAppUrl: '{protocol}://{site}.{domain}/d/plans/{id}',
        allowedOperations: [], //Since we already handled the allowedOperations in the parent object we can skip here to avoid redundancy
        responseObjectKey: 'item',
      },
      addons: {
        require_fields: [{ field: 'id' }, { field: 'type', value: 'addon' }],
        chargebeeAppUrl: '{protocol}://{site}.{domain}/d/addons/{id}',
        allowedOperations: [],
        responseObjectKey: 'item',
      },
      charges: {
        require_fields: [{ field: 'id' }, { field: 'type', value: 'charge' }],
        chargebeeAppUrl: '{protocol}://{site}.{domain}/d/charges/{id}',
        allowedOperations: [],
        responseObjectKey: 'item',
      },
    },
  },
  item_families: {
    require_fields: [],
    chargebeeAppUrl: '',
    allowedOperations: [
      'create_an_item_family',
      'update_an_item_family',
      'retrieve_an_item_family',
    ],
    responseObjectKey: 'item_family',
    subResources: {
      //Identified as subMapping in the ChargebeeSiteLink.tsx
      product_families: {
        require_fields: [{ field: 'id' }],
        chargebeeAppUrl:
          '{protocol}://{site}.{domain}/d/product_families/{id}/edit',
        allowedOperations: [], //Since we already handled the allowedOperations in the parent object we can skip here to avoid redundancy
        responseObjectKey: 'item_family',
      },
    },
  },
  coupons: {
    require_fields: [{ field: 'id' }],
    chargebeeAppUrl: '{protocol}://{site}.{domain}/d/coupons/{id}',
    allowedOperations: [
      'create_a_coupon_for_items',
      'update_a_coupon_for_items',
      'retrieve_a_coupon',
    ],
    responseObjectKey: 'coupon',
  },
  subscriptions: {
    require_fields: [{ field: 'id' }],
    chargebeeAppUrl: '{protocol}://{site}.{domain}/d/subscriptions/{id}',
    allowedOperations: [
      'create_subscription_for_items',
      'update_subscription_for_items',
      'retrieve_a_subscription',
    ],
    responseObjectKey: 'subscription',
  },
};
